import {
  Alert,
  AlertIcon,
  Box,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  allowedOrigins: string[]
}

const AllowedOriginsDisplay = ({ allowedOrigins }: Props): React.ReactElement | null => {
  const { t } = useTranslation()

  if (!allowedOrigins || allowedOrigins.length === 0) {
    return null
  }

  return (
    <Alert status="info">
      <AlertIcon />
      <Box>
        <Text>
          {t(
            'allowed_origins_info',
            'This Web Proxy source trusts the following origins. Proxying assets from other domains will result in an error.',
          )}
        </Text>
        <Text mt={2}>
          {t('origins', 'Origins')}: {allowedOrigins.join(', ')}
        </Text>
      </Box>
    </Alert>
  )
}

export default AllowedOriginsDisplay
